<div> <button mat-icon-button mat-dialog-close class="close-dialog">
    <mat-icon>close</mat-icon>
</button>
<h2 mat-dialog-title> Client associated with service: {{selectedService.name}} </h2>
<div class="mat-dialog-title-content">
    <div class="scroll-container">
        <mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="code">
                <mat-header-cell *matHeaderCellDef>
                    Client Code
                </mat-header-cell>
                <mat-cell *matCellDef="let item">
                    {{item.code}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="title">
                <mat-header-cell *matHeaderCellDef>
                   Title
                </mat-header-cell>
                <mat-cell *matCellDef="let item">
                    {{item.title}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="description">
                <mat-header-cell *matHeaderCellDef>
                   Description
                </mat-header-cell>
                <mat-cell *matCellDef="let item">
                    {{item.description}}
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close> Close </button>
</div>
</div>